import React, { useState } from 'react'
import s from './ApplyFormApplicationType.module.css'
import SelectField from '../../SelectField'
import ApplyStepButtons from '../../ApplyStepButtons'
import ApplyStepIcon from '../../ApplyStepIcon'
import ApplyFormLabel from '../ApplyFormLabel'
import * as Sentry from '@sentry/nextjs'

function ApplyFormApplicationType({ onSubmit, initialValues }) {
  const [errors, setErrors] = useState([])

  const [fieldValues, setFieldValues] = useState({
    applicationType: initialValues.applicationType || 'Model',
    otherRepresentation: initialValues.otherRepresentation || 'No',
    representationName: initialValues.representationName || '',
  })
  const [showRepresentationName, setShowRepresentationName] = useState(fieldValues.otherRepresentation === 'Yes' || false)
  const showModelTalentQuestion = initialValues.office !== 'chicago';

  const handleAttrChange = (attr, val) => {
    const fields = { ...fieldValues }
    fields[attr] = val
    setFieldValues(fields)

    if (attr === 'otherRepresentation') {
      if (val === 'Yes') {
        setShowRepresentationName(true)
      } else {
        setShowRepresentationName(false)
      }
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const newErrors = Object.keys(fieldValues).filter((f) => {
      if (f === 'representationName' && fieldValues.otherRepresentation === 'No') {
        // No validation required here
        return false
      }
      return !fieldValues[f]
    })
    if (newErrors.length) {
      setErrors(newErrors)
    } else {

      const submitValues = {
        ...fieldValues,
        representationName: fieldValues.otherRepresentation === 'Yes' ? fieldValues.representationName : null,
      }

      Sentry.addBreadcrumb({
        category: 'form',
        message: 'Application Type Submitted',
        level: 'debug',
        data: submitValues,
      })

      onSubmit(submitValues)
    }
  }

  return (
    <div className={s.container}>
      <form onSubmit={handleSubmit}>
        <h1 className={s.title}>Application Type</h1>

        {showModelTalentQuestion && (
          <>
          <ApplyFormLabel
            errors={errors}
            attrs={['applicationType']}
            label='Are you applying as a MODEL or TALENT?'
          />
          <div className={s.columns}>
            <div className={s.column}>
              <div className={s.field}>
                <SelectField
                  onChange={handleAttrChange}
                  name='applicationType'
                  options={Array('Model', 'Talent')}
                  label='Are you applying as a MODEL or TALENT?'
                  value={fieldValues.applicationType}
                  className={s.applicationTypeInput}
                  inputClassName={s.selectInput}
                  optionsClassName={s.selectOptions}
                  optionClassName={s.selectOption}
                />
              </div>
            </div>
          </div>
          </>
        )}


        <ApplyFormLabel
          errors={errors}
          attrs={[
            { attr: 'otherRepresentation', label: 'agency or representative' },
            { attr: 'representationName', label: 'agency or representative' },
          ]}
          label='Are you represented by someone else?'
        />

        <div className={s.column}>
          <div className={s.field}>
            <SelectField
              onChange={handleAttrChange}
              name='otherRepresentation'
              options={Array('Yes', 'No')}
              label='Are you represented by someone else?'
              value={fieldValues.otherRepresentation}
              className={s.otherRepresentationInput}
              inputClassName={s.selectInput}
              optionsClassName={s.selectOptions}
              optionClassName={s.selectOption}
            />
          </div>

          {showRepresentationName && <input
            type='text'
            placeholder='Name of agency or representative'
            id='representationName'
            name='representationName'
            className={s.representationName}
            value={fieldValues.representationName}
            onChange={(e) => handleAttrChange('representationName', e.target.value)}
          />
          }
        </div>

        <ApplyStepButtons back='/apply' />
      </form>
      <ApplyStepIcon step='2' />
    </div>
  )
}

export default ApplyFormApplicationType
